import { MeetingFormatEnum } from "@/types/MeetingFormat";

const STORAGE_PREFIX = "livestream-guest-name:";

export function getStoredLivestreamGuestName({
  productId,
}: {
  productId: string;
}): string | undefined {
  if (typeof sessionStorage === "undefined") return undefined;
  const name = sessionStorage.getItem(`${STORAGE_PREFIX}${productId}`)?.trim();
  return name || undefined;
}

export function setStoredLivestreamGuestName({
  productId,
  name,
}: {
  productId: string;
  name: string;
}) {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(`${STORAGE_PREFIX}${productId}`, name.trim());
}

export function livestreamNeedsGuestNamePrompt({
  meetingFormat,
  requireAuthentication,
  isStaffJoinLink,
  hasAuthTokenFromQuery,
  participantName,
}: {
  meetingFormat: MeetingFormatEnum;
  requireAuthentication: boolean;
  isStaffJoinLink: boolean;
  hasAuthTokenFromQuery: boolean;
  participantName?: string;
}): boolean {
  if (meetingFormat !== MeetingFormatEnum.LIVESTREAM) return false;
  if (requireAuthentication) return false;
  if (isStaffJoinLink || hasAuthTokenFromQuery) return false;
  if (participantName?.trim()) return false;
  return true;
}
